module.exports = __webpack_public_path__ + "img/connected.236e8334.svg";